var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 408.8 408.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.7 0H55.1A55.14 55.14 0 0 0 0 55.1v298.6a55.14 55.14 0 0 0 55.1 55.1h298.6a55.14 55.14 0 0 0 55.1-55.1V55.1A55.14 55.14 0 0 0 353.7 0m-28.9 204.6s0 39.1-5 57.9a30.238 30.238 0 0 1-21.2 21.2c-18.8 5-94.2 5-94.2 5s-75.2 0-94.2-5.2A30.238 30.238 0 0 1 89 262.3c-5-18.6-5-57.9-5-57.9s0-39.1 5-57.9a30.685 30.685 0 0 1 21.2-21.4c18.8-5 94.2-5 94.2-5s75.4 0 94.2 5.2a30.238 30.238 0 0 1 21.2 21.2c5.2 18.8 5 58.1 5 58.1",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m180.4 240.5 62.7-36.1-62.7-36.1v72.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.16206ed36e07d9e6856253b8d8b7d584.svg";
export { ForwardRef as ReactComponent };